import type Geometry from 'ol/geom/Geometry'
import type Feature from 'ol/Feature'

type DeviceFeatureMetadata = {
  mode: 'on' | 'off' | 'label'
  type: 'device'
  hasViolations: boolean
  ordersCount: number
  ordersWithViolationsCount: number
}

export const setDeviceFeatureMetadata = <Field extends keyof DeviceFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
  value: DeviceFeatureMetadata[Field],
) => {
  target.set(field, value)
}

export const getDeviceFeatureMetadata = <Field extends keyof DeviceFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
): DeviceFeatureMetadata[Field] | undefined => {
  return target.get(field)
}

export const removeDeviceFeatureMetadata = <Field extends keyof DeviceFeatureMetadata>(
  target: Feature<Geometry>,
  field: Field,
) => {
  target.unset(field)
}
